export default {
  methods: {
    async exportData() {
      if (
        this.$refs.baseLevelTableContainer.$refs.lazyLoadingTable.totalHits >
        9999
      ) {
        await this.$root.$warningDialog.open({
          message: this.$t('BaseLevelTableModule.Dialogs.exportMaximum'),
          resolveLabel: this.$t('Common.ok')
        });
        this.fetchExcelData();
        return;
      }
      this.fetchExcelData();
    },
  },
}